import { c as _c } from "react/compiler-runtime";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import { WAVE_LABELS } from "@/helpers/waves/waves.constants";
export default function WaveTypeIcon(t0) {
  const $ = _c(2);
  const {
    waveType
  } = t0;
  const t1 = WAVE_LABELS[waveType];
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="tw-flex tw-items-center"><span className="tw-text-sm tw-font-medium tw-text-iron-50">{t1}</span></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}